<template>
  <nav class="navbar navbar-expand-lg ">
    <div class="container-fluid">
      <a class="navbar-brand">
        <i v-if="this.$route.meta.class" :class="this.$route.meta.class"></i>
        {{ $route.meta.title }}
      </a>
      <button type="button"
              class="navbar-toggler navbar-toggler-right"
              :class="{toggled: $sidebar.showSidebar}"
              aria-expanded="false"
              @click="toggleSidebar">
        <span class="navbar-toggler-bar burger-lines"></span>
        <span class="navbar-toggler-bar burger-lines"></span>
        <span class="navbar-toggler-bar burger-lines"></span>
      </button>
      <div class="collapse navbar-collapse justify-content-end">
        <ul class="nav navbar-nav mr-auto d-none">
          <form class="navbar-form navbar-left navbar-search-form" role="search">
            <div class="input-group">
              <label for="searchInput"></label>
              <i class="nc-icon nc-zoom-split"></i>
              <input id="searchInput" type="text" value="" class="form-control" placeholder="Search...">
            </div>
          </form>
        </ul>
        <a :href="`${$env.VUE_APP_FRONTEND_BASE_URL}/`"
          class="m-r-20 text-primary" target="_blank">
          <i class="fa fa-external-link"></i>
          Site
        </a>
        <a :href="`${$env.VUE_APP_API_BASE_URL}/public/documentation`"
          class="m-r-20 text-primary" target="_blank">
          <i class="fa fa-database"></i>
          Public API
        </a>
        <a :href="`${$env.VUE_APP_API_BASE_URL}/documentation`"
          class="m-r-20 text-primary" target="_blank">
          <i class="fa fa-database"></i>
          API
        </a>
        <el-dropdown trigger="click" class="m-r-20">
          <span class="el-dropdown-link">
            <i class="fa fa-cog"></i>
            <i class="el-icon-arrow-down el-icon--right"></i>
          </span>
          <el-dropdown-menu slot="dropdown">
            <el-dropdown-item icon="el-icon-plus">Créer un article</el-dropdown-item>
          </el-dropdown-menu>
        </el-dropdown>
        <div class="navbar-minimize">
          <button class="btn btn-outline btn-fill btn-round btn-icon d-none d-lg-block" @click="minimizeSidebar">
            <i :class="$sidebar.isMinimized ? 'fa fa-ellipsis-v' : 'fa fa-navicon'"></i>
          </button>
        </div>

      </div>
    </div>
  </nav>
</template>
<script>
  export default {
    computed: {
      routeName () {
        const {name} = this.$route
        return this.capitalizeFirstLetter(name)
      }
    },
    data () {
      return {
        activeNotifications: false
      }
    },
    methods: {
      capitalizeFirstLetter (string) {
        return string.charAt(0).toUpperCase() + string.slice(1)
      },
      toggleNotificationDropDown () {
        this.activeNotifications = !this.activeNotifications
      },
      closeDropDown () {
        this.activeNotifications = false
      },
      toggleSidebar () {
        this.$sidebar.displaySidebar(!this.$sidebar.showSidebar)
      },
      hideSidebar () {
        this.$sidebar.displaySidebar(false)
      },
      minimizeSidebar () {
        this.$sidebar.toggleMinimize()
      }
    }
  }

</script>
<style>

</style>
